export const PUBLIC_PATH = "";  // can be used to set a sub-path e.g. when not running as root-path but e.g. as cooldomain.de/pat/...
export const API_BASE_PATH = "";